import React, { useState } from 'react';
import { TemplatesPage } from './TemplatesPage';
import { TemplateRouter } from '../templates/TemplateRouter';

export const TemplateApp: React.FC = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Listen for navigation changes
  React.useEffect(() => {
    const handlePathChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen for navigation
    window.addEventListener('popstate', handlePathChange);
    
    // Also listen for our internal navigation
    const originalPushState = window.history.pushState;
    window.history.pushState = function(state, title, url) {
      originalPushState.call(window.history, state, title, url);
      setCurrentPath(window.location.pathname);
    };

    return () => {
      window.removeEventListener('popstate', handlePathChange);
      window.history.pushState = originalPushState;
    };
  }, []);

  const renderCurrentPage = () => {
    // Templates marketplace
    if (currentPath === '/templates') {
      return <TemplatesPage />;
    }
    
    // Individual template routes
    if (currentPath.startsWith('/templates/')) {
      return <TemplateRouter templatePath={currentPath} />;
    }
    
    // Organization-based template routes
    const orgMatch = currentPath.match(/^\/([a-zA-Z0-9_]+)\/templates\/(.+)$/);
    if (orgMatch) {
      const templatePath = `/templates/${orgMatch[2]}`;
      return <TemplateRouter templatePath={templatePath} />;
    }
    
    // Standalone template routes (without /templates prefix)
    const standaloneTemplateMatch = currentPath.match(/^\/(legal|support|homeimprovement|universal|general|healthcare|education|interview|sales)\/(preview|demo|.+)$/);
    if (standaloneTemplateMatch) {
      const templatePath = `/templates${currentPath}`;
      return <TemplateRouter templatePath={templatePath} />;
    }
    
    // Organization-based standalone template routes
    const orgStandaloneMatch = currentPath.match(/^\/([a-zA-Z0-9_]+)\/(legal|support|homeimprovement|universal|general|healthcare|education|interview|sales)\/(preview|demo|.+)$/);
    if (orgStandaloneMatch) {
      const templatePath = `/templates/${orgStandaloneMatch[2]}/${orgStandaloneMatch[3]}`;
      return <TemplateRouter templatePath={templatePath} />;
    }

    // Public demo routes (viral marketing)
    if (currentPath.startsWith('/public/demo')) {
      const templatePath = currentPath; // Pass the full path to TemplateRouter
      return <TemplateRouter templatePath={templatePath} />;
    }

    // Public video-connect routes
    if (currentPath.startsWith('/public/video-connect')) {
      const templatePath = currentPath; // Pass the full path to TemplateRouter
      return <TemplateRouter templatePath={templatePath} />;
    }

    // Organization-based public demo routes
    const orgPublicMatch = currentPath.match(/^\/([a-zA-Z0-9_]+)\/public\/demo(\/.*)?$/);
    if (orgPublicMatch) {
      const demoPath = orgPublicMatch[2] || '';
      const templatePath = `/public/demo${demoPath}`;
      return <TemplateRouter templatePath={templatePath} />;
    }

    // External session routes - redirect to universal waiting room
    if (currentPath.startsWith('/external/')) {
      const sessionId = currentPath.split('/external/')[1];
      if (sessionId) {
        // Redirect to universal waiting room with external session ID
        window.history.replaceState({}, '', `/templates/universal/waiting/${sessionId}?external=true`);
        return <TemplateRouter templatePath={`/templates/universal/waiting/${sessionId}`} />;
      }
    }

    // Fallback
    return <TemplatesPage />;
  };

  return (
    <div className="template-app">
      {renderCurrentPage()}
    </div>
  );
};